import { ItemModalReadOnly } from "./ItemModalReadOnly";

export default ItemModalReadOnly;
